var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.033,
    height: 36.022,
    viewBox: "0 0 36.033 36.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recording_3",
    "data-name": "recording 3",
    transform: "translate(65.113 739.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M-52.008-735.8a9.606,9.606,0,0,0-9.606,9.606,9.606,9.606,0,0,0,9.606,9.606,9.606,9.606,0,0,0,9.606-9.606A9.606,9.606,0,0,0-52.008-735.8Zm4.015,11.352a2.26,2.26,0,0,1-2.26,2.26h-3.5a2.257,2.257,0,0,1-1.6-.662,2.257,2.257,0,0,1-.66-1.6v-3.5a2.257,2.257,0,0,1,2.257-2.257h3.5a2.257,2.257,0,0,1,1.6.66,2.258,2.258,0,0,1,.662,1.6Z",
    transform: "translate(4.905 4.905)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M-36.284-739.3H-57.922a7.2,7.2,0,0,0-7.192,7.193v21.637a7.19,7.19,0,0,0,7.192,7.193h21.637a7.19,7.19,0,0,0,5.094-2.1,7.19,7.19,0,0,0,2.11-5.091v-21.638a7.2,7.2,0,0,0-7.2-7.193Zm-10.807,30.019A12.007,12.007,0,0,1-59.1-721.289,12.008,12.008,0,0,1-47.091-733.3a12.007,12.007,0,0,1,12.007,12.007A12.007,12.007,0,0,1-47.1-709.281Z",
    transform: "translate(0)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingIcon);
export default __webpack_public_path__ + "static/media/recordingIcon.6ccafdf928626cac97c234a7884b9338.svg";
export { ForwardRef as ReactComponent };